import React from 'react';
import {injectIntl} from 'react-intl';
import Alert from 'react-bootstrap/Alert';

import StarterList from '../../components/starter/StarterList';
import API from '../../common/utils/API';

export class UserList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            users: [],
            roles: [],
            // Meta for pagination
            page: 1,
            pageSize: 12,
            pageCount: 2,
            total: 0,
            // Search parameters
            searchTimeout: 0,
            search: '',
            role: '',

            error: false,
        };
    }

    async componentDidMount() {
        await Promise.all([this.fetchUsers(), this.fetchRoles()]);
    }

    fetchUsers = async (pageNumber = 1) => {
        try {
            const result = await API.users.get(
                pageNumber,
                this.state.search,
                this.state.role,
            );

            this.setState({
                users: result.items,
                page: result.page,
                pageSize: result.pageSize,
                pageCount: result.pageCount,
                total: result.total,
                error: false,
            });
        } catch (e) {
            this.setState(
                {
                    error: true,
                },
                this.clearErrorMessage,
            );
        }
    };

    fetchRoles = async () => {
        try {
            const {roles} = await API.roles.getAll();

            this.setState({
                roles,
                error: false,
            });
        } catch (e) {
            this.setState(
                {
                    error: true,
                },
                this.clearErrorMessage,
            );
        }
    };

    clearErrorMessage = () => {
        setTimeout(() => {
            if (this.state.error) {
                this.setState({error: false});
            }
        }, 5000);
    };

    handlePageChange = (pageNumber) => {
        return this.fetchUsers(pageNumber);
    };

    handleSearchKeywordChange = (event) => {
        /* istanbul ignore else */
        if (this.state.searchTimeout) {
            clearTimeout(this.state.searchTimeout);
        }

        this.setState({
            [event.target.name]: event.target.value,
            searchTimeout: setTimeout(() => {
                return this.fetchUsers(1);
            }, 300),
        });
    };

    handleSearchKeywordClear = (field = 'search') => {
        this.setState(
            {
                pageSize: 1,
                [field]: '',
            },
            () => {
                return this.fetchUsers(1);
            },
        );
    };

    render() {
        const rolesOptions = this.state.roles.map((role) => ({
            value: role.id,
            label: role.name,
        }));

        return (
            <div data-test='userListComponent'>
                <Alert
                    data-test='errorAlert'
                    variant='danger'
                    className='mb-4'
                    show={this.state.error}
                >
                    <p className='mb-0'>
                        {this.props.intl.formatMessage({
                            id: 'ERROR_PAGES.LOADING_DATA',
                        })}
                    </p>
                </Alert>
                <StarterList
                    onSearchKeywordClear={this.handleSearchKeywordClear}
                    onSearchKeywordChange={this.handleSearchKeywordChange}
                    searchKeyword={this.state.search}
                    onPageChange={this.handlePageChange}
                    page={this.state.page}
                    pageSize={this.state.pageSize}
                    total={this.state.total}
                    data={{
                        headerTitles: [
                            '#',
                            this.props.intl.formatMessage({
                                id: 'USERS.USER_FIRST_NAME_TABLE_HEADER',
                            }),
                            this.props.intl.formatMessage({
                                id: 'USERS.USER_LAST_NAME_TABLE_HEADER',
                            }),
                            this.props.intl.formatMessage({
                                id: 'USERS.USER_ROLE_TABLE_HEADER',
                            }),
                            this.props.intl.formatMessage({
                                id: 'USERS.USER_EMAIL_TABLE_HEADER',
                            }),
                        ],
                        rows: this.state.users.map((user) => ({
                            content: [
                                user.id,
                                user.firstName,
                                user.lastName,
                                user.roles,
                                user.email,
                            ],
                            link: `/users/${user.id}`,
                        })),
                    }}
                    addNewPermission={'USERS_CREATE'}
                    addNewLink={`users/create`}
                    searchFields={[
                        {
                            options: rolesOptions,
                            name: 'role',
                            placeholder: this.props.intl.formatMessage({id:'USERS.FILTER_ROLES_PLACEHOLDER'}),
                            value: this.state.role,
                        },
                    ]}
                />
            </div>
        );
    }
}

export default injectIntl(UserList);
